var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBombshellIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 119.71 145.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e5117e;}.cls-2{fill:#916214;}.cls-3,.cls-5{fill:#fff;}.cls-3{stroke:#cc5c9c;stroke-miterlimit:10;stroke-width:4.03px;}.cls-4{fill:#1d1d1b;}.cls-6{fill:#db69a2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Marshmallow_with_alcohol",
    "data-name": "Marshmallow with alcohol"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    className: "cls-1",
    d: "M72.63,145.11H46.49c-57.21,0-50.15-87.84-38.36-124.74A47.16,47.16,0,0,1,13.8,13.5,46.1,46.1,0,0,1,46.59,0h26A46,46,0,0,1,102,10.51c1.34,1.11,2.63,2.28,3.85,3.51,12.17,12.6,13.14,32.1,13.5,48.59.49,19,1.55,39.14-6.63,56.78-5.46,11.79-14.14,20.56-30.86,24.77A45.06,45.06,0,0,1,72.63,145.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    className: "cls-2",
    d: "M26.8,9.43a59.53,59.53,0,0,1,6.5-3.1C57.12-3.32,81.11,4.4,94.5,10.46"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    className: "cls-3",
    cx: 32.99,
    cy: 35.28,
    r: 26.29
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    className: "cls-4",
    cx: 31.62,
    cy: 34.68,
    r: 18.17
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    className: "cls-5",
    cx: 25.6,
    cy: 25.5,
    r: 8.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    className: "cls-6",
    d: "M11.58,61.21c.81-.91,9.64,5,24,4.72,7-.13,11.58-1.65,12-.82S42,70.56,34.46,71.28C21.8,72.29,10.67,62.26,11.58,61.21Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    className: "cls-3",
    cx: 85.8,
    cy: 35.28,
    r: 26.29
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    className: "cls-4",
    cx: 84.43,
    cy: 34.68,
    r: 18.17
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    className: "cls-5",
    cx: 75.98,
    cy: 25.5,
    r: 8.62
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    className: "cls-6",
    d: "M106.8,61.21c-.81-.91-9.64,5-24,4.72-7-.13-11.57-1.65-12-.82S76.48,70.56,84,71.22C96.64,72.29,107.79,62.26,106.8,61.21Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBombshellIcon);
export default __webpack_public_path__ + "static/media/BombshellIcon.c1d1efd43490cdc5a9a5c79fbc086e93.svg";
export { ForwardRef as ReactComponent };